/** Faixa contextual: utilizador está num fluxo de demonstração. */
export const PRODUCT_DEMO_REMINDER_SETTINGS_BANNER_TITLE = 'Demonstração';

export const PRODUCT_DEMO_REMINDER_SETTINGS_BANNER_BODY =
  'Você está num tour guiado. Os dados que configurar aqui são reais; em seguida vamos simular o restante do ciclo.';

export const PRODUCT_DEMO_REMINDER_SETTINGS_WELCOME_TITLE = 'Bem-vindo ao RetornaAr';

export const PRODUCT_DEMO_REMINDER_SETTINGS_WELCOME_LEAD =
  'Nesta etapa você ajusta a periodicidade dos lembretes e valida o WhatsApp com uma mensagem de teste — antes de cadastrar instalações de verdade.';

export const PRODUCT_DEMO_REMINDER_SETTINGS_WELCOME_BODY =
  'Em poucos minutos você percorre um exemplo completo: avisos no WhatsApp, cadastro de serviço, lembretes e painel. O tour destaca a periodicidade e, em seguida, o teste de envio com o número da sua conta.';

export const PRODUCT_DEMO_REMINDER_SETTINGS_WELCOME_CTA = 'Começar';

export const PRODUCT_DEMO_REMINDER_SETTINGS_WELCOME_SKIP = 'Pular demonstração';

export const PRODUCT_DEMO_REMINDER_SETTINGS_SPOTLIGHT_TITLE = 'Periodicidade e horário dos avisos';

export const PRODUCT_DEMO_REMINDER_SETTINGS_SPOTLIGHT_BODY =
  'Aqui você escolhe quantos dias antes da manutenção o RetornaAr deve avisar você e a que horas prefere receber a mensagem no WhatsApp. Essas opções valem para todos os lembretes da sua conta.';

export const PRODUCT_DEMO_REMINDER_SETTINGS_SPOTLIGHT_CTA = 'Entendi, quero ajustar';

export const PRODUCT_DEMO_REMINDER_SETTINGS_SPOTLIGHT_SKIP = 'Pular demonstração';

export const PRODUCT_DEMO_REMINDER_WHATSAPP_SPOTLIGHT_TITLE = 'Mensagem de teste no WhatsApp';

export const PRODUCT_DEMO_REMINDER_WHATSAPP_SPOTLIGHT_BODY =
  'Use o botão para enviar uma mensagem de teste ao número indicado nesta secção. Quando o WhatsApp confirmar o recebimento, avançamos para a periodicidade dos lembretes.';

export const PRODUCT_DEMO_REMINDER_WHATSAPP_SPOTLIGHT_CTA = 'Continuar para periodicidade';

export const PRODUCT_DEMO_REMINDER_WHATSAPP_SPOTLIGHT_SKIP = 'Pular demonstração';

/** Texto de apoio quando o CTA está desativado (aguardando confirmação do webhook). */
export const PRODUCT_DEMO_REMINDER_WHATSAPP_SPOTLIGHT_WAIT_HINT =
  'Envie a mensagem de teste e aguarde a confirmação no WhatsApp para continuar.';
